export const CUSTOMER_CONSTRAINTS = {
    name: { maxLength: 100, label: 'Customer name' },
    url: { maxLength: 512, label: 'Website URL' },
    note: { maxLength: 4000, label: 'Note' },
    email: { maxLength: 256, label: 'Email address' },
    phone: { maxLength: 256, label: 'Phone number' },
    creditLimit: { label: 'Credit limit' },
    taxExemptNumber: { maxLength: 30, label: 'Tax exempt number' },
    paymentTerms: { label: 'Payment terms' },
    shipTerms: { label: 'Ship terms' },
    status: { label: 'Relationship status' },
    number: { maxLength: 30, label: 'Account number' },
    deliveryPreferences: { maxLength: 5_000, label: 'Delivery preferences' },
    brands: { label: 'Brands' },
};
//# sourceMappingURL=constraints.js.map